// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Dm9mc-Simple_root{display:flex;flex-direction:column;justify-content:center;align-items:center}.OHlou-Simple_merchant{height:2.3333333333rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Dm9mc-Simple_root",
	"merchant": "OHlou-Simple_merchant"
};
export default ___CSS_LOADER_EXPORT___;
